module.exports = __webpack_public_path__ + "static/media/editrox.96374fdd.png";